import React from "react";
import { Button, Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import Iconify from "@/components/iconify/iconify";

const ToggleButton = styled(Button)<{ selected?: boolean }>(
  ({ selected, theme }) => ({
    fontFamily: "Proxima Nova, sans-serif",
    fontWeight: 700,
    fontSize: "14px",
    lineHeight: "24px",
    borderRadius: "8px",
    height: "40px",
    minHeight: "40px",
    maxHeight: "40px",
    minWidth: "140px",
    padding: "0 12px",
    textTransform: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    ...(selected
      ? {
          color: "#fff",
          backgroundColor: "#118d57",
          boxShadow: "0px 8px 16px 0px rgba(34,197,94,0.24)",
          "&:hover": {
            backgroundColor: "#0f7a4a",
          },
        }
      : {
          color: "primary.main",
          border: `1px solid ${theme.palette.primary.main}`,
        }),
  }),
);

interface PlanToggleButtonProps {
  selected: boolean;
  onClick: () => void;
  fullWidth?: boolean;
}

export default function PlanToggleButton({
  selected,
  onClick,
  fullWidth = false,
}: PlanToggleButtonProps) {
  return (
    <ToggleButton
      color={selected ? "success" : "primary"}
      fullWidth={fullWidth}
      selected={selected}
      onClick={onClick}
      // Remove startIcon and instead handle centering manually
      sx={{
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
      }}
    >
      {selected ? (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <Iconify icon="mdi:check-circle" width={20} />
        </Box>
      ) : (
        "Add to Plan"
      )}
    </ToggleButton>
  );
}
